import { Component, OnInit } from '@angular/core';

import { rastreamentosModuleName } from "../shared/data.service";
import { FrotaApiService } from "../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../bens/frotas/shared/frota.service";
import {RastreamentoService} from "../shared/rastreamento.service";
import {frotasQuery, frotasQueryComGPS} from "../../bens/frotas/shared/data.service";
import {UtilService} from "../../shared/services/util.service";
import {FilterService} from "../../shared/services/filter.service";
import {AutoCompleteService} from "../../shared/components/autocomplete/autocomplete.service";

@Component({
    template: require('./rastreamento-veiculos.component.html'),
    styles: [require('./rastreamento-veiculos.component.css')]
})
export class RastreamentoVeiculosComponent implements OnInit {
    list: any[] = [];
    loading: boolean = true;
    module: any = rastreamentosModuleName;

    frotaSelectId = 'frota';
    frotaQuery: any = {};
    frotaSearch: any = {};
    statusSearch: any = {};
    statusList: any[] = [];

    private cloneList: any[] = [];

    constructor(
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _rastreamentoService: RastreamentoService,
        private _utilService: UtilService,
        private _filterService: FilterService,
        private _autocompleteService: AutoCompleteService
    ) { }

    ngOnInit() {
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);
        this.frotaQuery.where.and.push({gpsImei: {neq: null}});
        this.frotaQuery.where.and.push({gpsModeloId: {neq: null}});

        this.statusList = [
            {Key: null, Value: '— Status —'},
            {Key: 1, Value: 'Ligado'},
            {Key: 2, Value: 'Desligado'},
            {Key: 3, Value: 'Não informado'}
        ];

        this.clickClearSearch();
        this.getAll();
    }

    clickGoLog(item: any) {
        this._rastreamentoService.goToHistoric(item.id);
    }

    clickGoRastreamento(item: any) {
        this._rastreamentoService.setSessionStorage(item);
        this._rastreamentoService.goToMap();
    }

    clickClearSearch() {
        this.frotaSearch = {};
        this.statusSearch = this.statusList[0];

        this._autocompleteService.setValueOnSelect2(null, "frota");

        this.onFilter();
    }

    getFrotasObject(object: any) {
        this.frotaSearch = object;
        this.onFilter();
    }

    frotaTemplateResult = (function(state: any) {
        return this._frotaService.templateResult(state, false);
    }.bind(this));

    changeStatus() {
        this.onFilter();
    }

    private getAll() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach((item: any) => {
                    if (item.Imagens.length) {
                        item.imageUrl = item.Imagens[0].url;
                    }
                });
                this.list = Response;
                this.cloneList = this._utilService.cloneObject(Response);
            }
            this.loading = false;
        }.bind(this));

        const cat: number = this._frotaService.getTipoVeiculo();
        let query: any = this._utilService.cloneObject(frotasQueryComGPS);
        query.where.ativo = true;
        this._frotaApiService.onGetAllRastreamento(cat, query, onDone);
    }

    private onFilter() {
        let l: any[] = this.cloneList;
        if (this.frotaSearch.id) {
            l = this._filterService.filterArray(l, this.frotaSearch.id, ["id"]);
        }

        if (this.statusSearch.Key) {
            let x: number, lenX: number,
                list: any[] = [];
            for (x = 0, lenX = l.length; x < lenX; x++) {
                if (this.statusSearch.Key === 1) {
                    if (l[x].Rastreamento) {
                        if (l[x].Rastreamento.ligado) {
                            list.push(l[x]);
                        }
                    }
                } else if (this.statusSearch.Key === 2) {
                    if (l[x].Rastreamento) {
                        if (!l[x].Rastreamento.ligado) {
                            list.push(l[x]);
                        }
                    }
                } else if (this.statusSearch.Key === 3) {
                    if (!l[x].Rastreamento) {
                        list.push(l[x]);
                    }
                }
            }
            l = list;
        }

        this.list = l;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamento-veiculos/rastreamento-veiculos.component.ts
 **/